import { joinUrl } from '@ocodelib/util/http';
import { config } from '../config';

export function apiUrlOf(str: string): string {
  if (str.startsWith('http://') || str.startsWith('https://')) {
    return str;
  }
  return joinUrl(config.apiBaseURL, str);
}
